import { Component, Prop } from 'vue-property-decorator' ;
import { ContentLoader } from 'vue-content-loader' ;
import LoaderPalette from '../../../../components/loader-palette';

@Component({
    components: {
        ContentLoader
    }
})
class BlockInfosLoader extends LoaderPalette {

    @Prop({ default: '100%', type: [String,Number] })
    height: number | string
    @Prop({ default: '100%', type: [String, Number] })
    width: number | string
    @Prop({ default: true, type: [Boolean] })
    hasMargin: boolean

    dt_radius: number

    constructor(){
        super()
        this.dt_radius= 3
    }

    get coHeight(){
      return this.coHeightISString ? this.height : this.height + 'px'
    }

    get coHeightISString(){
      return typeof this.height === 'string'
    }
}

export default BlockInfosLoader



// WEBPACK FOOTER //
// ./src/containers/building-monitor/loaders/block-infos-loader/index.ts